export enum FindControlMode {
  MultiSelect,
  SingleSelect,
  Administration,
}
